import React from "react";

import { ELEMENT_IDS } from "../../constants";

export default function useNavbarPosition() {
  const [navbarPosition, setNavbarPosition] = React.useState(0);

  React.useEffect(() => {
    const updateNavbarPosition = () => {
      const navbar = document.getElementById(ELEMENT_IDS.NAVBAR);
      if (navbar) {
        setNavbarPosition(navbar.getBoundingClientRect().bottom);
      } else {
        setNavbarPosition(0);
      }
    };

    updateNavbarPosition();

    window.addEventListener("resize", updateNavbarPosition);

    const navbar = document.getElementById(ELEMENT_IDS.NAVBAR);
    const resizeObserver = navbar
      ? new ResizeObserver(updateNavbarPosition)
      : null;
    if (resizeObserver) resizeObserver.observe(navbar);

    return () => {
      window.removeEventListener("resize", updateNavbarPosition);
      if (resizeObserver) resizeObserver.disconnect();
    };
  }, []);

  return { navbarPosition };
}
